const APP_VERSION = process.env.REACT_APP_VERSION
const BACKEND_API = process.env.REACT_APP_BACKEND_API
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN

export { APP_VERSION, BACKEND_API, SENTRY_DSN }
